
























































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment-timezone';
import './OrderReportListCard.scss';
import { formatNumber, getOrderItemCardIcon } from '@/utils/helpers';
import constants from '@/utils/constants';

@Component({
  filters: {
    formatDate(val: any) {
      let date: any = val;
      if (moment(date).isValid()) {
        date = moment(date).format('MMM DD, YYYY HH:mm:ss');
      }
      return date;
    }
  }
})
export default class OrderItemCard extends Vue {
  @Prop() item!: any;
  @Prop() activeOrderType!: String;
  @Prop() isPaymentDetailShow!: boolean;
  @Prop(Array) items!: Array<any>;
  @Prop(Object) orderStatus!: Object;
  @Prop(Function) switchOrderDetail!: Function;
  @Prop(Function) checkOutItems!: Function;
  tabelNumberShow: boolean = false;
  formatPayDetails: any = this.item.paymentDetails;
  orderDetailsPrice: Array<any> = [];
  getOrderItemCardIcon = getOrderItemCardIcon;
  formatPrice = formatNumber;
  public constants: any = constants;

  mounted() {
    for (let key in this.item.paymentDetails) {
      this.formatPayDetails[key] = formatNumber(this.item.paymentDetails[key]);
    }
    (this.item.orderDetails || []).map(item => {
      this.orderDetailsPrice.push(formatNumber(item.price));
    });
    if (this.item['orderType'] === constants.QRO) {
      this.tabelNumberShow = false;
    } else {
      this.tabelNumberShow = true;
    }
  }
}
